import * as React from 'react';
import { t } from 'i18next';

import { BaseDialog } from './BaseDialog';

interface NewProjectDialogProps {
    saveCallback: () => void;
    noSaveCallback: () => void;
    cancelCallback: () => void;
}

export class NewProjectDialog extends React.Component<NewProjectDialogProps, {}> {
    public render(): JSX.Element {
        return (
            <BaseDialog
                label={t('Your drawing has not been saved yet.')}
                buttons={[
                    {label: t('Save'), callback: this.props.saveCallback},
                    {label: t('Do not save'), callback: this.props.noSaveCallback},
                    {label: t('Cancel'), green: true, callback: this.props.cancelCallback}
                ]}
                closeCallback={this.props.cancelCallback}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/dialog/NewProjectDialog.tsx